const galleryDe = {
    "file_upload_successful": "Datei-Upload erfolgreich",
    "file_upload_error": "Fehler beim Hochladen der Datei",
    "attach_files": "Anhängen von Dateien",
    "files_selected": "Ausgewählte Dateien",
    "upload": "Hochladen",
    "uploading": "Hochladen",
    "maximum_file_size": "Die maximal zulässige Uploadgröße beträgt 10 MB.",
    "download": "Herunterladen",
    "open_in_new_tab": "In neuem Tab öffnen",
    "delete_file": "Datei löschen",
    "confirm_delete": "Möchten Sie diese Datei wirklich löschen?",
    "image_in_use": "Das ausgewählte Bild wird in den folgenden aktiven Menüpunkten verwendet:",
    "image_in_use_tip": "Um diese Datei zu löschen, entfernen Sie sie bitte aus allen aktiven Einträgen.",
    "file_deleted_successfully": "Datei erfolgreich gelöscht",
    "error_deleting_file": "Fehler beim Löschen der Datei",
    "confirm_selection": "Auswahl bestätigen",
    "file_deletion_forbidden": "Dateilöschung verboten"
};

export default galleryDe;
